{
  "name": "my.mojo.ui",
  "version": "1.0.0",
  "scripts": {
    "start": "npm run dev",
    "start:ci": "cross-env NODE_ENV=development parcel serve ./src/index.html --no-cache &",
    "dev": "cross-env NODE_ENV=development parcel serve ./src/index.html",
    "dev-no-cache": "cross-env NODE_ENV=development parcel serve ./src/index.html --no-cache",
    "local-no-cache": "cross-env NODE_ENV=local parcel serve ./src/index.html --no-cache",
    "build-test": "cross-env NODE_ENV=test-env parcel build ./src/index.html",
    "build-prod": "cross-env NODE_ENV=production parcel build ./src/index.html",
    "test": "vitest",
    "eslint:check": "eslint --max-warnings 260",
    "eslint:fix": "eslint --fix",
    "prettier:check": "prettier --check \"./**/*.{ts,tsx}\" --ignore-path .gitignore",
    "prettier:fix": "prettier --write \"./**/*.{js,jsx,ts,tsx}\" --ignore-path .gitignore",
    "knip": "knip",
    "prepare": "husky install"
  },
  "dependencies": {
    "@fortawesome/fontawesome-svg-core": "^1.2.35",
    "@fortawesome/free-solid-svg-icons": "^5.15.3",
    "@fortawesome/react-fontawesome": "^0.1.14",
    "@microsoft/clarity": "^1.0.0",
    "@radix-ui/react-popover": "^1.0.2",
    "@react-spring/web": "^9.6.1",
    "@sentry/browser": "^7.1.1",
    "@sentry/tracing": "^7.1.1",
    "axios": "^0.34.0",
    "date-fns": "^4.1.0",
    "dayjs": "^1.10.4",
    "deepmerge": "^4.2.2",
    "email-validator": "^2.0.4",
    "fast-clone": "^1.5.13",
    "filestack-react": "5.0.0",
    "js-cookie": "^3.0.7",
    "jwt-decode": "^3.1.2",
    "keyboardjs": "^2.6.4",
    "mojo-storybook-v2-library": "git@github.com:mojomortgages/mojo.storybook.v2.library.git",
    "polished": "^4.1.2",
    "prop-types": "^15.8.1",
    "pure-react-carousel": "^1.35.0",
    "react": "^18.3.1",
    "react-device-detect": "^2.1.2",
    "react-dom": "^18.3.1",
    "react-error-boundary": "^3.1.3",
    "react-ga4": "^2.1.0",
    "react-helmet": "^6.1.0",
    "react-hooks-visible": "^1.1.1",
    "react-hot-toast": "^2.4.0",
    "react-is": "^17.0.2",
    "react-number-format": "5.4.5",
    "react-router-dom": "^5.2.0",
    "recoil": "^0.7.7",
    "smartlook-client": "^6.0.0",
    "smooth-scroll-into-view-if-needed": "^1.1.32",
    "styled-components": "^5.3.11",
    "styled-normalize": "^8.1.1",
    "swr": "^2.0.0",
    "uuid": "^11.1.1"
  },
  "devDependencies": {
    "@babel/preset-env": "^7.16.11",
    "@babel/preset-react": "^7.16.7",
    "@babel/preset-typescript": "^7.16.7",
    "@eslint/eslintrc": "^3.3.4",
    "@eslint/js": "9.39.3",
    "@parcel/transformer-babel": "^2.8.3",
    "@parcel/transformer-image": "^2.0.0",
    "@parcel/transformer-svg-react": "^2.5.0",
    "@testing-library/jest-dom": "^5.16.5",
    "@testing-library/react": "^13.4.0",
    "@testing-library/user-event": "^14.4.3",
    "@types/deepmerge": "^2.2.0",
    "@types/intercom-web": "^2.8.13",
    "@types/keyboardjs": "^2.5.0",
    "@types/mixpanel-browser": "^2.35.7",
    "@types/node": "^20.14.11",
    "@types/react": "^18.3.31",
    "@types/react-dom": "^18.3.7",
    "@types/react-router-dom": "^5.1.7",
    "@types/sinon": "^21.0.0",
    "@types/styled-components": "^5.1.35",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.56.1",
    "@typescript-eslint/parser": "^8.56.1",
    "babel-loader": "^8.2.5",
    "babel-plugin-styled-components": "^2.3.0",
    "buffer": "^5.7.1",
    "cross-env": "^7.0.3",
    "eslint": "9.26.0",
    "husky": "^8.0.1",
    "jest-transform-stub": "^2.0.0",
    "jsdom": "^26.1.0",
    "knip": "^5.26.0",
    "lint-staged": "^13.0.3",
    "msw": "^2.12.2",
    "parcel": "^2.5.0",
    "prettier": "^2.8.4",
    "process": "^0.11.10",
    "react-test-renderer": "^18.3.1",
    "svgo": "2.5.0",
    "tsconfig-paths-webpack-plugin": "^4.0.0",
    "typescript": "^5.5.3",
    "vite": "^6.3.5",
    "vitest": "^3.2.4"
  },
  "alias": {
    "state": "./src/State.ts",
    "logging": "./src/Logging.tsx",
    "hooks": "./src/hooks",
    "lib": "./src/lib",
    "models": "./src/models",
    "components": "./src/components",
    "styles": "./src/styles",
    "reducers": "./src/reducers",
    "templates": "./src/templates",
    "pages": "./src/pages",
    "assets": "./src/assets",
    "experiments": "./src/experiments",
    "contexts": "./src/contexts",
    "testing": "./src/testing"
  },
  "browserslist": [
    "last 4 versions"
  ],
  "lint-staged": {
    "*.{ts,tsx,js,jsx}": [
      "eslint --fix",
      "prettier --write"
    ]
  },
  "overrides": {
    "react-refresh": "0.9.0"
  },
  "prettier": {
    "endOfLine": "lf",
    "semi": false,
    "printWidth": 100
  },
  "engines": {
    "node": "24"
  }
}
